export default "__VITE_ASSET__f405a43a__"